import { TSortableColumn } from '../../Components/GenericTable/types';
import { SxProps } from '@mui/material';
import { classes } from '../../Components/GenericTable/styles';

export const emailBatchColumns = [
  {
    id: 'email_template',
    label: 'Email Template',
    sortable: true,
    canToggle: false,
    enabled: true
  },
  {
    id: 'user',
    label: 'User',
    sortable: true,
    canToggle: false,
    enabled: true
  },
  {
    id: 'recipients',
    label: 'Recipients',
    sortable: false,
    canToggle: false,
    enabled: true
  },
  {
    id: 'delayed_to',
    label: 'Delayed to',
    sortable: false,
    canToggle: false,
    enabled: true
  },
  {
    id: 'created_at',
    label: 'Created at',
    sortable: true,
    canToggle: false,
    enabled: true
  }
];

export const headerStyles = (
  name: (typeof emailBatchColumns)[number]['id'] | 'checkbox' | 'actions',
  tableHovered: boolean
): SxProps => {
  switch (name) {
    case 'email_template':
      return {
        ...classes.sticky,
        ...classes.itemTitleTableCell,
        left: '0',
        minWidth: '180px',
        paddingLeft: '60px !important',
        '& span': {
          width: '130px'
        }
      };
    case 'user':
      return { minWidth: '150px' };
    case 'recipients':
      return {
        minWidth: '100px',
        textAlign: 'right'
      };
    case 'delayed_to':
      return { minWidth: '120px' };
    case 'created_at':
      return { minWidth: '130px' };
    case 'actions':
      return {
        ...classes.actionsColumnHeader,
        ...(tableHovered && classes.scrollShadowVisible)
      };
    default:
      return { minWidth: '90px' };
  }
};
